module.exports = __webpack_public_path__ + "img/undo1.b7b5b947.png";